import { render, staticRenderFns } from "./DateMessageCard.vue?vue&type=template&id=cf2960ae&scoped=true&"
import script from "./DateMessageCard.vue?vue&type=script&lang=js&"
export * from "./DateMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./DateMessageCard.vue?vue&type=style&index=0&id=cf2960ae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2960ae",
  null
  
)

export default component.exports